import Immutable from 'seamless-immutable';
import { InviteMemberModalState } from '@adsk/acs-admin-ui-components-shared-components';
import { USER_ACCESSES, DEFAULT_TRIAL_ACCESS_LEVELS } from '../constants';

export const initialState = ({ show }) => {
  return Immutable.from({
    ...InviteMemberModalState.initialState({
      showMainModal: show,
    }),
    selectedAccessLevel: USER_ACCESSES.ADMIN,
    productsAccesses: DEFAULT_TRIAL_ACCESS_LEVELS,
  });
};

export const reducer = () => (state, action) => {
  switch (action.type) {
    default:
      return InviteMemberModalState.reducer(state, action);
  }
};
